/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TransportAirRocketIcon16Light } from './TransportAirRocketIcon16Light';
import { TransportAirRocketIcon16Regular } from './TransportAirRocketIcon16Regular';
import { TransportAirRocketIcon16Solid } from './TransportAirRocketIcon16Solid';
import { TransportAirRocketIcon20Light } from './TransportAirRocketIcon20Light';
import { TransportAirRocketIcon20Regular } from './TransportAirRocketIcon20Regular';
import { TransportAirRocketIcon20Solid } from './TransportAirRocketIcon20Solid';
import { TransportAirRocketIcon24Regular } from './TransportAirRocketIcon24Regular';
import { TransportAirRocketIcon24Solid } from './TransportAirRocketIcon24Solid';
import { TransportAirRocketIcon32Regular } from './TransportAirRocketIcon32Regular';
import { TransportAirRocketIcon64Regular } from './TransportAirRocketIcon64Regular';
var sizes = {
    16: {
        light: TransportAirRocketIcon16Light,
        regular: TransportAirRocketIcon16Regular,
        solid: TransportAirRocketIcon16Solid,
    },
    20: {
        light: TransportAirRocketIcon20Light,
        regular: TransportAirRocketIcon20Regular,
        solid: TransportAirRocketIcon20Solid,
    },
    24: {
        regular: TransportAirRocketIcon24Regular,
        solid: TransportAirRocketIcon24Solid,
    },
    32: {
        regular: TransportAirRocketIcon32Regular,
    },
    64: {
        regular: TransportAirRocketIcon64Regular,
    },
};
export var TransportAirRocketIcon = forwardRef('TransportAirRocketIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
